<template>
  <div class="search-form">
    <el-input v-model="eid" placeholder="ID" style="width:70px;" @change="$emit('change', 'eid')"/>
    <LessonSelect :level="level" v-model="lid"></LessonSelect>
    <TypeSelect :level="0" v-model="tid"></TypeSelect>
    <el-input v-model="search" placeholder="输入关键字搜索" style="width:200px;"/>
  </div>
</template>

<script>
import LessonSelect from './../LessonSelect'
import TypeSelect from './../../../components/exercise/TypeSelect'

export default {
  name: 'ListSearchForm',
  props: {
    olid: Number
  },
  data () {
    return {
      eid: null,
      lid: this.olid,
      tid: null,
      search: null,
    }
  },
  components: { LessonSelect, TypeSelect },
  watch: {
    lid () {
      this.$emit('change', 'lid')
    },
    tid () {
      this.$emit('change', 'tid')
    },
    search () {
      this.$emit('change', 'search')
    }
  }
}
</script>

